import _ from 'lodash'
import constants from '../constants'

const initialPartsState = {
  AdditionalOption: [],
  DoorKnob: [],
  Latch: [],
  LockCommonFactory: [],
  LockCommon: [],
  LockAdditionalFactory: [],
  LockAdditional: [],
  LockPadCommon: [],
  LockPadAdditional: [],
  InsideColor: [],
  OutsideColor: [],
  InsidePanel: [],
  ForgedFinish: [],
  colors: []
};

const partsReducer = function(state = initialPartsState, action) {
  switch(action.type) {
    case constants.ACTIONS.FETCH_CONSTRUCTION_PARTS_SUCCESS:
      return Object.assign({}, state, action.payload);
  }

  return state;
};
export default partsReducer;


// WEBPACK FOOTER //
// ./app/javascript/app/reducers/parts.js